import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"

import store from "./store"
import { HoxRoot } from "hox"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <HoxRoot>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </HoxRoot>
)

serviceWorker.unregister()
